import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon, InputWithIcon, toast } from '@livable/saas-react-components';
import { Button, Grid, TextField, Typography } from '@mui/material';
import { useFormik } from 'formik';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import InputMask from 'react-input-mask';
import { useStore } from 'src/stores';
import {
// mfaPhoneSchema,
mfaSmsCodeInitialValues, mfaSmsCodeSchema } from 'src/utils/formValidation/MFA';
import useStyles from './styles';
const ChangeNumber = observer(props => {
  const insideModal = props.insideModal,
    phoneNumber = props.phoneNumber,
    setPhoneConfirmed = props.setPhoneConfirmed;
  const classes = useStyles({
    insideModal
  });
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const codeIsSent = store.account.userProfile.codeIsSent;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    clicked = _useState2[0],
    setIsClicked = _useState2[1];
  const sendCodeFormik = useFormik({
    enableReinitialize: true,
    initialValues: {
      phone: phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.replace('+1', '').replace('+38', '')
    },
    onSubmit: async values => {
      const phoneCode = store.account.featureFlagsStore.isUkrainianMobileCode ? '+38' : '+1';
      const data = {
        phone: "".concat(phoneCode).concat(values.phone.replace(/[^0-9+]/g, ''))
      };
      const updatePhoneNumber = async () => {
        const resp = await store.account.updatePhoneNumberAsync.run(data);
        return resp;
      };
      updatePhoneNumber().then(resp => {
        if (resp && resp.isSuccessful) {
          store.account.userProfile.setCodeIsSent(true);
          store.account.userProfile.updatePhone(data.phone);
          toast('info', {
            body: ['Confirmation code will be sent to your phone']
          }); // ? i18n
        }
      });
    }
  });
  const confirmCodeFormik = useFormik({
    initialValues: mfaSmsCodeInitialValues,
    validationSchema: mfaSmsCodeSchema
  });
  const confirmPhoneNumber = async data => {
    const resp = await store.account.confirmPhoneNumberAsync.run(data);
    return resp;
  };
  useEffect(() => {
    if (clicked) {
      confirmPhoneNumber({
        code: confirmCodeFormik.values.code.replaceAll('-', '')
      }).then(resp => {
        if (resp && resp.isSuccessful) {
          setPhoneConfirmed(true);
          store.account.userProfile.setAuthIsConfirmed(true);
          toast('success', {
            body: ['Phone number was successfully verified']
          }); // ? i18n
        }
      }).finally(() => setIsClicked(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clicked]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.authFieldWrapper, " ").concat(codeIsSent ? classes.success : '')
  }, /*#__PURE__*/React.createElement("form", {
    onSubmit: sendCodeFormik.handleSubmit
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    columnSpacing: 10,
    rowSpacing: 18
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, phoneNumber ? 'You will receive a text message with a confirmation code on your personal phone number' /* // ? i18n */ : t('mfa.enter_phone_number_auth'))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 5
  }, /*#__PURE__*/React.createElement(InputMask, {
    mask: "999-999-9999",
    value: sendCodeFormik.values.phone,
    onChange: sendCodeFormik.handleChange,
    onBlur: e => {
      if (!sendCodeFormik.touched.phone && /\d/.test(e.target.value)) sendCodeFormik.setFieldTouched('phone', true);
    },
    disabled: store.account.updatePhoneNumberAsync.inProgress || store.account.mfaFlowStore.timeCounted || store.account.mfaFlowStore.mfaIsActivated
  }, inputProps => /*#__PURE__*/React.createElement(TextField, _extends({}, inputProps, {
    type: "tel",
    fullWidth: true,
    id: "phone",
    name: "phone",
    variant: "outlined",
    label: t('general.phone_number'),
    disabled: store.account.updatePhoneNumberAsync.inProgress || store.account.mfaFlowStore.timeCounted || store.account.mfaFlowStore.mfaIsActivated,
    error: sendCodeFormik.touched.phone && Boolean(sendCodeFormik.errors.phone),
    helperText: sendCodeFormik.touched.phone && sendCodeFormik.errors.phone
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 7
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: store.account.updatePhoneNumberAsync.inProgress,
    type: "submit",
    variant: "text",
    'custom-attribute': '280-change-number'
  }, codeIsSent ? t('profile_settings.re-send_code') : t('profile_settings.send_confirmation_code')))))), codeIsSent ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.authFieldWrapper, " ").concat(store.account.userProfile.authIsConfirmed ? classes.success : '')
  }, /*#__PURE__*/React.createElement("form", {
    id: "confirm",
    onSubmit: confirmCodeFormik.handleSubmit
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    columnSpacing: 10,
    rowSpacing: 18
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('mfa.code_was_sent'))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 5
  }, /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "shield-keyhole"
    })
  }, /*#__PURE__*/React.createElement(InputMask, {
    onBlur: e => {
      if (e.target.value) confirmCodeFormik.handleBlur(e);
    },
    onChange: confirmCodeFormik.handleChange,
    disabled: store.account.confirmPhoneNumberAsync.inProgress,
    mask: "99-99-99",
    value: confirmCodeFormik.values.code
  }, inputProps => /*#__PURE__*/React.createElement(TextField, _extends({}, inputProps, {
    disabled: store.account.confirmPhoneNumberAsync.inProgress,
    fullWidth: true,
    helperText: confirmCodeFormik.touched.code && t(confirmCodeFormik.errors.code),
    id: "code",
    label: t('mfa.enter_code_auth'),
    name: "code",
    type: "tel",
    variant: "outlined"
  }))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 7
  }, /*#__PURE__*/React.createElement(Button, {
    form: "confirm",
    onClick: () => setIsClicked(true),
    type: "submit",
    variant: "text",
    'custom-attribute': '281-change-number'
  }, t('buttons.confirm')))))) : null);
});
export default ChangeNumber;